module.exports = __webpack_public_path__ + "static/media/algae6.e951c6e7.svg";